module.exports = __webpack_public_path__ + "img/USA_HIGH_GLYCEMIC.9eed8e00.png";